export default "__VITE_ASSET__C3eLhlM9__"